// extracted by mini-css-extract-plugin
export default {"detailArea":"styles_detailArea__+qav8","card":"styles_card__x5Fp9"};